import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'dynamicInvalidUploads',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Invalid Dynamic Uploads',
  },
}

const keys = {
  statKey: 'posted_invalid_prospects',
  componentKeys: [DATA_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const dynamicInvalidUploads = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { dynamicInvalidUploads }
